export default "__VITE_ASSET__RtQJJgCS__"